export default __webpack_public_path__ + "logo125fad71.png";